"use client";

import { useRef, type ReactNode } from "react";

import { useShorterThan } from "./use-shorter-than";
import * as styles from "./ListingLayout.module.scss";

const RESULTS_ID = "listing-results";

export interface ListingLayoutProps {
	rail: ReactNode;
	children: ReactNode;
}

export function ListingLayout({
	rail,
	children
}: ListingLayoutProps): JSX.Element {
	const filters = useRef<HTMLDivElement>(null);
	const results = useRef<HTMLDivElement>(null);
	const resultsAreShorter = useShorterThan(results, filters);

	return (
		<div
			className={styles["listing"]}
			data-results-shorter={resultsAreShorter || undefined}
		>
			<div className={styles["listing__rail"]}>
				<a href={`#${RESULTS_ID}`} className={styles["listing__skip"]}>
					Skip to products
				</a>
				<div ref={filters}>{rail}</div>
			</div>
			<div
				ref={results}
				id={RESULTS_ID}
				tabIndex={-1}
				className={styles["listing__results"]}
			>
				{children}
			</div>
		</div>
	);
}
